import { useQuery } from '@tanstack/react-query';
import { ApiError } from '@sw/api-client';
import { getTalentDetail, type GetTalentDetailParams } from './talentDetailApi';

export const TALENT_DETAIL_QUERY_KEY = ['talent', 'detail'] as const;

/**
 * Detail de un talent dentro de un shortlist. retry: false en 404 (caso terminal —
 * el talent o el shortlist no es accesible para este cliente).
 */
export function useTalentDetail(params: GetTalentDetailParams) {
  return useQuery({
    queryKey: [...TALENT_DETAIL_QUERY_KEY, params.shortlistPublicKey, params.talentPublicKey],
    queryFn: () => getTalentDetail(params),
    staleTime: 60_000,
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status === 404) return false;
      return failureCount < 2;
    },
  });
}
